export default __webpack_public_path__ + "static/media/close.ae65c90b.svg";